import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LandingPageModule from './LandingPageModule';
import HomePageConsumer from './HomePageConsumer';
import OctoxDemoPage from './OctoxDemoPage';

const Noop = () => {};

const DemoRoot = () => {
  const params = new URLSearchParams(window.location.search);
  const page = (params.get('page') || '').toLowerCase();

  if (!page || page === 'demo') {
    return <OctoxDemoPage onPrimaryAction={Noop} />;
  }

  if (page === 'octox') {
    return <OctoxDemoPage onPrimaryAction={Noop} />;
  }

  if (page === 'module') {
    return <LandingPageModule onJoinMember={Noop} onViewProducts={Noop} />;
  }

  return <HomePageConsumer onJoinMember={Noop} onNavigateToPartnership={Noop} onViewProducts={Noop} />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DemoRoot />
  </React.StrictMode>
);
